import { Select } from 'antd';
import React, { useState } from 'react';

const NON_DIGIT = /\D/g;

const PhoneNumbersInput = ({
  value = [],
  onChange,
  placeholder = 'Enter Phone Number',
  disabled = false,
}) => {
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (text) => setSearchValue(text?.replace(NON_DIGIT, ''));

  const handleChange = (values) => {
    const digitsOnly = (values || [])
      ?.map((entry) => String(entry)?.replace(NON_DIGIT, ''))
      ?.filter(Boolean);

    onChange?.([...new Set(digitsOnly)]);
    setSearchValue('');
  };

  return (
    <Select
      mode="tags"
      allowClear
      disabled={disabled}
      suffixIcon={null}
      notFoundContent={null}
      tokenSeparators={[',', ' ']}
      placeholder={placeholder}
      value={value}
      searchValue={searchValue}
      onSearch={handleSearch}
      onChange={handleChange}
    />
  );
};

export default PhoneNumbersInput;
